import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { HubPage } from '~/components/routes/logistics/hub-page'
import {
  LogisticsRecordRoute,
  logisticsRecordIdParam,
} from '~/components/routes/logistics/logistics-record-page'
import { LOGISTICS_HUB_READ } from '~/components/routes/logistics/tabs'
import { withRoutePermissions } from '~/utils/rbac'
import { logisticsSearchSchema } from '../-search-schema'

export const Route = createFileRoute('/_authenticated/logistics/hubs/$hubId')({
  staticData: {
    permission: LOGISTICS_HUB_READ,
  },
  component: HubDetailRoute,
  params: {
    parse: z.object({ hubId: logisticsRecordIdParam() }).parse,
  },
  // Mêmes paramètres que la page Logistique : les filtres de la liste suivent l'aller-retour.
  validateSearch: logisticsSearchSchema,
})
withRoutePermissions(Route)

function HubDetailRoute() {
  const { hubId } = Route.useParams()
  return (
    <LogisticsRecordRoute tab="hubs" search={Route.useSearch()} permission={LOGISTICS_HUB_READ}>
      {(search) => <HubPage hubId={hubId} search={search} />}
    </LogisticsRecordRoute>
  )
}
